import React from 'react';
import './WhereWeWork.css';
import afgMap from '../images/afg_map.jpg';
import DepartmentsPage from './DepartmentsPage';

import { useEffect } from 'react';
const WhereWeWork: React.FC = () => {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <div className="where-we-work-page">


      {/* Clean Map Section */}
      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>National Coverage</h2>
            <p>NORA operates in 34 provinces of Afghanistan through experienced and dedicated teams.</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA Operational Coverage" 
              className="clean-afghanistan-map"
            />
          </div>


        </div>
      </section>

      {/* Scope of Work Section */}
      <DepartmentsPage/>


    </div>
  );
};

export default WhereWeWork;